import { Component, OnInit, TemplateRef } from '@angular/core';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { G_StatusTypeViewModel } from 'src/app/viewmodels/g-settings/G_StatusTypeViewModel';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-status-type',
  templateUrl: './status-type.component.html',
  styleUrls: ['./status-type.component.scss']
})
export class StatusTypeComponent implements OnInit {
  modalRef: BsModalRef;
  public itemVm: G_StatusTypeViewModel = new G_StatusTypeViewModel();
  public vmListItems: any = [];
  public component_Title = "Status Type";

  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.spinner.show();
    this.getList();
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 3000);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._modalService.show(template);
  }

  ngAfterViewInit() {
    // this._jq.showSpinner();
  }

  getList() {
    this._jq.showSpinner(true);
    this._uow.statusTypeService.GetList().subscribe((res: any) => {
      this._jq.reinitDataTable(res);
      this.vmListItems = res;
      console.log(res);
      this._jq.showSpinner();
    }, (err) => {
      console.log(err);
    });
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.itemVm = new G_StatusTypeViewModel();
    }
  }

  // saveOrUpdate() {
  //   this._jq.showSpinner(true);
  //   this._uow.statusTypeService.Post(this.itemVm).subscribe((res: any) => {
  //     this.getList();
  //     this.modalRef.hide();
  //   }, (err) => {
  //     this._jq.showSpinner();
  //   });
  // }

  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
    }
  }

  conformDelete() {
    this._uow.statusTypeService.Delete(this.itemVm).subscribe((res: any) => {
      this.getList();
      this.modalRef.hide();
    }, (err) => {
      this._jq.showSpinner();
    });
  }

  // extrnal components
  onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.itemVm = new G_StatusTypeViewModel();
      this.getList();
    }
  }

}
